/* ============================================================
   Modern Product Card — behaviour
   - إضافة للسلة بدون Reload
   - تبديل صورة الكارت مع السواتش
   - صورة الهوفر بتتحمّل عند الحاجة بس (توفير داتا على الموبايل)
   ============================================================ */

(function () {
  'use strict';

  const SELECTORS = {
    form: '[data-card-add-form]',
    card: '.card-m',
    media: '.card-m__media',
    swatch: '.card-m__swatch',
    mainImg: '.card-m__img--main',
    hoverImg: '.card-m__img--hover',
    source: '.card-m__pic source',
  };

  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  // بيتحط بدري عشان الحجاب الأبيض يشتغل قبل ما الصور تترسم
  document.documentElement.classList.add('card-m-js');

  /* ---------- إظهار الصورة بعد التحميل ---------- */

  function markLoaded(img) {
    const media = img.closest(SELECTORS.media);
    if (media) media.classList.add('is-loaded');

    const card = img.closest(SELECTORS.card);
    if (card) maybeReveal(card);
  }

  // الكشف بيحصل بس لما الشرطين يتحققوا: الكارت دخل الشاشة، والصورة خلصت تحميل.
  // من غير كده الحركة بتجري على صورة لسه شفافة ومحدش بيشوفها.
  function maybeReveal(card) {
    if (card.dataset.seen !== '1') return;

    const media = card.querySelector(SELECTORS.media);
    const img = card.querySelector(SELECTORS.mainImg);

    if (img && media && !media.classList.contains('is-loaded')) return;

    card.classList.add('is-visible');
  }

  // listener واحد بالـ capture بيمسك تحميل أي صورة في الصفحة، حتى اللي بتتحقن بالـ AJAX
  // (الفلاتر، الـ pagination، والمنتجات المقترحة) — من غير أي MutationObserver
  document.addEventListener(
    'load',
    function (event) {
      const img = event.target;
      if (img.tagName === 'IMG' && img.classList.contains('card-m__img--main')) markLoaded(img);
    },
    true
  );

  document.addEventListener(
    'error',
    function (event) {
      const img = event.target;
      if (img.tagName === 'IMG' && img.classList.contains('card-m__img--main')) markLoaded(img);
    },
    true
  );

  // الصور اللي اتحمّلت من الكاش قبل ما الـ JS يشتغل
  function scanLoadedImages(root) {
    const instant = [];

    (root || document).querySelectorAll(SELECTORS.mainImg).forEach((img) => {
      if (!img.complete || img.naturalWidth === 0) return;

      // اتحمّلت من الكاش خلاص — نرفع الحجاب من غير انتقال بدل وميض أبيض
      const media = img.closest(SELECTORS.media);
      if (media) {
        media.classList.add('is-instant');
        instant.push(media);
      }

      markLoaded(img);
    });

    if (instant.length) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => instant.forEach((media) => media.classList.remove('is-instant')));
      });
    }
  }

  /* ---------- تحميل صورة الهوفر عند الحاجة ---------- */

  function loadHoverImage(card) {
    const img = card.querySelector(SELECTORS.hoverImg);
    if (!img || img.dataset.loaded === 'true') return;

    img.dataset.loaded = 'true';
    if (img.dataset.hoverSizes) img.sizes = img.dataset.hoverSizes;
    if (img.dataset.hoverSrcset) img.srcset = img.dataset.hoverSrcset;
    img.src = img.dataset.hoverSrc;

    img.addEventListener('load', () => img.classList.add('is-ready'), { once: true });
  }

  if (canHover) {
    // pointerover الخاص بالهوفر اتنقل لـ listener واحد مجمّع تحت
    // (كان في 3 listeners منفصلين بيعملوا closest() على نفس الحدث)
    document.addEventListener(
      'focusin',
      function (event) {
        const card = event.target.closest(SELECTORS.card);
        if (card) loadHoverImage(card);
      },
      true
    );
  }

  /* ---------- توست (بيستخدم بس لو مفيش دراور ولا notification) ---------- */

  let toastEl = null;
  let toastTimer = null;

  function showToast(message) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'card-m-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }

    toastEl.textContent = message;
    requestAnimationFrame(() => toastEl.classList.add('is-visible'));

    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('is-visible'), 2600);
  }

  /* ---------- الوصول لكارت دراور / نوتيفيكيشن بتوع Dawn ---------- */

  function getCartElement() {
    // الدراور له الأولوية، وبعده الـ notification (لو الإعداد متظبط كده)
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function getSectionIds(cartEl) {
    if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
      return cartEl.getSectionsToRender().map((section) => section.id);
    }
    return ['cart-icon-bubble'];
  }

  function updateCartIconFallback(sectionsHtml) {
    const bubbleHtml = sectionsHtml && sectionsHtml['cart-icon-bubble'];
    const target = document.getElementById('cart-icon-bubble');
    if (!bubbleHtml || !target) return;

    const parsed = new DOMParser().parseFromString(bubbleHtml, 'text/html');
    const fresh = parsed.querySelector('.shopify-section') || parsed.body.firstElementChild;
    if (fresh) target.innerHTML = fresh.innerHTML;
  }

  /* ---------- الإضافة للسلة ---------- */

  document.addEventListener('submit', function (event) {
    const form = event.target.closest(SELECTORS.form);
    if (!form) return;

    event.preventDefault();
    if (form.classList.contains('is-loading')) return;

    const button = form.querySelector('button[type="submit"]');
    if (button?.disabled || button?.getAttribute('aria-disabled') === 'true') return;
    const label = form.querySelector('.card-m__quick-label');
    const originalLabel = label ? label.textContent : '';

    const cartEl = getCartElement();
    const sectionIds = getSectionIds(cartEl);

    form.classList.add('is-loading');
    if (button) button.disabled = true;

    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        items: [
          {
            id: Number(form.querySelector('[name="id"]').value),
            quantity: Number(form.querySelector('[name="quantity"]')?.value || 1),
          },
        ],
        // بنطلب سكاشن السلة في نفس الريكوست — ريكوست واحد بدل اتنين
        sections: sectionIds,
        sections_url: window.location.pathname,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        form.classList.remove('is-loading');
        if (button) button.disabled = false;

        if (data.status) {
          showToast(data.description || data.message || window.SalehThemeText("cart.add_error", "Unable to add this product. Please try again."));
          return;
        }

        // renderContents بتحدّث محتوى الدراور وبتفتحه لوحدها (نفس اللي بيعمله product-form في Dawn)
        if (cartEl && typeof cartEl.renderContents === 'function') {
          if (cartEl.classList.contains('is-empty')) cartEl.classList.remove('is-empty');
          cartEl.renderContents(data);
        } else {
          updateCartIconFallback(data.sections);
          showToast(window.SalehThemeText("cart.added", "Added to cart"));
        }

        if (label) {
          label.textContent = window.SalehThemeText("cart.added_check", "Added to cart ✓");
          form.classList.add('is-added');
          setTimeout(() => {
            form.classList.remove('is-added');
            label.textContent = originalLabel;
          }, 2000);
        }

        document.dispatchEvent(new CustomEvent('card-m:cart-updated', { detail: data }));
      })
      .catch(() => {
        form.classList.remove('is-loading');
        if (button) button.disabled = false;
        showToast(window.SalehThemeText("cart.connection_error", "Connection error. Please try again."));
      });
  });

  /* ---------- تبديل الصورة مع السواتش ---------- */

  function swapImage(swatch) {
    const card = swatch.closest(SELECTORS.card);
    const src = swatch.dataset.swatchImg;
    if (!card || !src) return;

    const img = card.querySelector(SELECTORS.mainImg);
    const source = card.querySelector(SELECTORS.source);
    if (!img) return;

    // لازم نغيّر الـ <source> كمان وإلا المتصفح هيفضل ماسك نسخة الـ WebP القديمة
    if (source) source.srcset = swatch.dataset.swatchSrcset || src;
    img.srcset = swatch.dataset.swatchSrcset || src;
    img.src = src;

    card.querySelectorAll(SELECTORS.swatch).forEach((el) => el.classList.remove('is-active'));
    swatch.classList.add('is-active');

    // الصورة الأساسية اتغيرت، فبنرجّع الجاليري لأول سلايد
    if (card.classList.contains('card-m--gallery')) setIndex(card, 0);
  }

  document.addEventListener('click', function (event) {
    const swatch = event.target.closest(SELECTORS.swatch);
    if (!swatch) return;

    event.preventDefault();
    // الكليك أقوى من الهوفر: نلغي أي تبديل معلّق عشان ميرجعش
    // يبدّل لصورة سواتش تاني بعد اختيار اليوزر
    clearTimeout(swatchTimer);
    lastSwatch = swatch;
    swapImage(swatch);
  });

  // هوفر السواتش اتنقل هو كمان للـ listener المجمّع تحت
  let lastSwatch = null;
  let swatchTimer = null;

  /* ============================================================
     Quick View
     ============================================================ */

  const QV = {
    overlay: null,
    panel: null,
    trigger: null,
    cache: new Map(),
    variants: [],
  };

  function buildOverlay() {
    if (QV.overlay) return;

    QV.overlay = document.createElement('div');
    QV.overlay.className = 'qv-overlay';
    QV.overlay.setAttribute('role', 'dialog');
    QV.overlay.setAttribute('aria-modal', 'true');
    QV.overlay.hidden = false;

    QV.panel = document.createElement('div');
    QV.panel.className = 'qv-panel';
    QV.overlay.appendChild(QV.panel);
    document.body.appendChild(QV.overlay);

    QV.overlay.addEventListener('click', (e) => {
      if (e.target === QV.overlay || e.target.closest('[data-qv-close]')) closeQuickView();
    });
  }

  function openQuickView(url, trigger) {
    buildOverlay();
    QV.trigger = trigger || null;
    QV.panel.innerHTML = '';
    var alreadyOpen = QV.overlay.classList.contains('is-open');
    /* لازم تتشال قبل كل فتحة، وإلا البانل بيبدأ من مكانه النهائي
       (لو النافذة اتفتحت قبل كده) والانزلاق مبيبانش. */
    QV.overlay.classList.remove('is-ready');
    QV.overlay.classList.add('is-open');
    if (!alreadyOpen) {
      /* position: fixed مش overflow: hidden — دي متجاهلة على iOS Safari
         (وعلى متصفحات إنستجرام/فيسبوك جوه الآيفون لأنهم WebKit). */
      if (window.themeScrollLock) window.themeScrollLock.lock();
      else document.body.style.overflow = 'hidden';
    }

    const load = QV.cache.has(url)
      ? Promise.resolve(QV.cache.get(url))
      : fetch(`${url}${url.includes('?') ? '&' : '?'}section_id=card-quick-view`)
          .then((res) => {
            if (!res.ok) throw new Error('quick view unavailable');
            return res.text();
          })
          .then((html) => {
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            const root = parsed.querySelector('[data-qv-root]');
            if (!root) throw new Error('quick view markup missing');
            QV.cache.set(url, root.outerHTML);
            return root.outerHTML;
          });

    load
      .then((html) => {
        if (!QV.overlay.classList.contains('is-open')) return;
        QV.panel.innerHTML = html;
        setupQuickView();

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            if (QV.overlay.classList.contains('is-open')) {
              QV.overlay.classList.add('is-ready');
            }
          });
        });
      })
      .catch(() => {
        closeQuickView();
        window.location.href = url; // fallback: نروح لصفحة المنتج
      });
  }

  function closeQuickView() {
    if (!QV.overlay) return;
    var wasOpen = QV.overlay.classList.contains('is-open');
    QV.overlay.classList.remove('is-open');
    QV.overlay.classList.remove('is-ready');
    if (wasOpen) {
      if (window.themeScrollLock) window.themeScrollLock.unlock();
      else document.body.style.overflow = '';
    }
    QV.variants = [];
    if (QV.trigger) QV.trigger.focus();
    setTimeout(() => {
      if (QV.overlay && !QV.overlay.classList.contains('is-open')) QV.panel.innerHTML = '';
    }, 250);
  }

  function setupQuickView() {
    const root = QV.panel.querySelector('[data-qv-root]');
    if (!root) return;

    const dataEl = root.querySelector('[data-qv-variants]');
    try {
      QV.variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    } catch (e) {
      QV.variants = [];
    }

    const closeBtn = root.querySelector('[data-qv-close]');
    if (closeBtn) closeBtn.focus();

    setupQuickViewNav(root);
    updateQuickViewState(root);
  }

  /* الأسهم بتتعطّل عند الطرفين بدل ما تفضل شغالة ومتعملش حاجة.
     passive عشان مانعطلش سلاسة السكرول. */
  function setupQuickViewNav(root) {
    const slider = root.querySelector('[data-qv-slider]');
    const navs = root.querySelectorAll('[data-qv-nav]');
    if (!slider || !navs.length) return;

    const sync = () => {
      /* في RTL بعض المتصفحات بترجّع scrollLeft بالسالب، فبناخد المطلق. */
      const pos = Math.abs(slider.scrollLeft);
      const max = slider.scrollWidth - slider.clientWidth;
      navs.forEach((btn) => {
        const forward = Number(btn.dataset.qvNav) > 0;
        const atEnd = forward ? pos >= max - 2 : pos <= 2;
        btn.classList.toggle('is-disabled', atEnd);
      });
    };

    slider.addEventListener('scroll', sync, { passive: true });
    sync();
  }

  function selectedOptions(root) {
    return Array.from(root.querySelectorAll('[data-qv-option]')).map((group) => {
      const active = group.querySelector('.qv__value.is-selected');
      return active ? active.dataset.qvValue : null;
    });
  }

  function updateQuickViewState(root) {
    if (!QV.variants.length) return;

    const chosen = selectedOptions(root);
    const match = QV.variants.find((v) => v.options.every((opt, i) => chosen[i] == null || opt === chosen[i]));

    // شطب القيم اللي مش متاحة مع الاختيار الحالي
    root.querySelectorAll('[data-qv-option]').forEach((group, groupIndex) => {
      group.querySelectorAll('.qv__value').forEach((btn) => {
        const test = chosen.slice();
        test[groupIndex] = btn.dataset.qvValue;
        const exists = QV.variants.some(
          (v) => v.options.every((opt, i) => test[i] == null || opt === test[i]) && v.available
        );
        btn.classList.toggle('is-unavailable', !exists);
      });

      const label = group.querySelector('[data-qv-option-selected]');
      const active = group.querySelector('.qv__value.is-selected');
      if (label && active) label.textContent = active.dataset.qvValue;
    });

    const idInput = root.querySelector('[data-qv-variant-id]');
    const priceEl = root.querySelector('[data-qv-price]');
    const atc = root.querySelector('[data-qv-atc]');
    const atcLabel = root.querySelector('.qv__atc-label');
    const mainImg = root.querySelector('[data-qv-main-img]');

    if (!match) {
      if (atc) atc.disabled = true;
      if (atcLabel) atcLabel.textContent = window.SalehThemeText("product.unavailable", "Unavailable");
      return;
    }

    if (idInput) idInput.value = match.id;

    if (priceEl) {
      priceEl.innerHTML = match.compare_at_price
        ? `<span class="qv__price-sale">${match.price}</span><s class="qv__price-was">${match.compare_at_price}</s>`
        : `<span class="qv__price-regular">${match.price}</span>`;
    }

    if (atc) atc.disabled = !match.available;
    if (atcLabel) atcLabel.textContent = match.available ? window.SalehThemeText("product.add_to_cart", "Add to cart") : window.SalehThemeText("product.sold_out", "Sold out");

    if (match.image) {
      const slider = root.querySelector('[data-qv-slider]');
      const slide = slider && slider.querySelector(`[data-qv-image="${CSS.escape(match.image)}"]`);

      if (slide) {
        slider.scrollLeft = slide.offsetLeft - slider.offsetLeft;
      } else if (mainImg) {
        mainImg.src = match.image;
      }
    }
  }

  /*
    تمرير السلايدر بأنيميشن بإيدنا بدل behavior: 'smooth'.

    السبب: قفل التمرير بيحط `position: fixed` على الـ body وهو شرط
    عشان iOS يوقف تمرير الصفحة ورا النافذة — وفي الحالة دي كروم
    **بيتجاهل behavior: 'smooth' تمامًا** والسلايدر مبيتحركش خالص
    (الـ auto بتشتغل عادي). اتقاس على المتجر: smooth = صفر حركة.

    الـ tween هنا مضمون في كل الحالات، وبيحترم تقليل الحركة.
    scroll-snap بيتقفل مؤقتًا: مع mandatory المتصفح بيحاول يسنّب مع
    كل فريم فالحركة بتطلع متقطعة.
  */
  /*
    تحريك السلايدر شريحة بشريحة.

    مفيش أنيميشن بإيدنا ولا behavior: 'smooth' هنا عن قصد:
      * `smooth` **بتتجاهل تمامًا** وقفل التمرير حاطط
        `position: fixed` على الـ body (وده شرط عشان iOS يوقف تمرير
        الصفحة ورا النافذة) — اتقاس: صفر حركة.
      * و tween بإيدنا بيتخانق مع `scroll-snap-type: mandatory`،
        المتصفح بيعيد السنّب مع كل فريم فالنتيجة بتطلع عشوائية.

    القفزة المباشرة لموضع الشريحة مضمونة في الحالتين، والسنّب بيخلي
    الوقفة نظيفة. offsetLeft نسبي للحاوية فبيشتغل في RTL برضو.
  */
  function qvSlideBy(slider, dir) {
    const slides = Array.prototype.slice.call(slider.querySelectorAll('.qv__slide'));
    if (!slides.length) return;

    const edge = slider.getBoundingClientRect().left;
    let index = 0;
    let nearest = Infinity;
    slides.forEach((slide, i) => {
      const gap = Math.abs(slide.getBoundingClientRect().left - edge);
      if (gap < nearest) {
        nearest = gap;
        index = i;
      }
    });

    const next = slides[Math.max(0, Math.min(slides.length - 1, index + dir))];
    if (next) slider.scrollLeft = next.offsetLeft - slider.offsetLeft;
  }

  /* ---------- أحداث الكويك فيو ---------- */

  document.addEventListener('click', function (event) {
    // فتح
    const trigger = event.target.closest('[data-quick-view]');
    if (trigger) {
      event.preventDefault();
      openQuickView(trigger.dataset.quickView, trigger);
      return;
    }

    if (!QV.overlay || !QV.overlay.classList.contains('is-open')) return;
    const root = QV.panel.querySelector('[data-qv-root]');
    if (!root) return;

    // أسهم السلايدر
    const nav = event.target.closest('[data-qv-nav]');
    if (nav) {
      const slider = root.querySelector('[data-qv-slider]');
      const slide = slider && slider.querySelector('.qv__slide');
      if (slider && slide) {
        /* خطوة = عرض الشريحة + المسافة. الاتجاه بيتقلب في RTL لأن
           الإزاحة الموجبة بتروح ناحية اليمين البصري في الحالتين. */
        qvSlideBy(slider, Number(nav.dataset.qvNav));
      }
      return;
    }

    // اختيار قيمة
    const value = event.target.closest('.qv__value');
    if (value) {
      const group = value.closest('[data-qv-option]');
      group.querySelectorAll('.qv__value').forEach((b) => b.classList.remove('is-selected'));
      value.classList.add('is-selected');
      group.querySelectorAll('.qv__value').forEach((button) => button.setAttribute('aria-pressed', button === value ? 'true' : 'false'));
      updateQuickViewState(root);
      return;
    }

  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && QV.overlay && QV.overlay.classList.contains('is-open')) closeQuickView();
  });

  // بعد ما المنتج يتضاف بنقفل النافذة عشان الدراور يبان
  document.addEventListener('card-m:cart-updated', function () {
    if (QV.overlay && QV.overlay.classList.contains('is-open')) closeQuickView();
  });

  /* ============================================================
     جاليري الكارت — سوايب + دوتس + تحميل ذكي

     الفكرة باختصار:
     - السلايد الأولى بس هي اللي ليها src حقيقي في الـ HTML.
     - باقي الصور مستنية في data-src ومحطوط مكانها SVG 1×1 جوه الصفحة
       (صفر ريكوست، صفر بايت).
     - أول ما اليوزر يبيّن نية (لمس الكارت أو قرّب بالماوس) بننزّل
       الصورة اللي بعدها بس — مش كل الصور.
     - كل ما يتحرك سلايد، بنجهّز اللي بعدها. يعني اللي مبيسحبش
       مبيحمّلش ولا بايت زيادة.
     ============================================================ */

  const GAL = {
    card: '.card-m--gallery',
    track: '[data-card-track]',
    slide: '.card-m__slide',
    dot: '.card-m__dot',
    THRESHOLD: 0.16, // نسبة من عرض الكارت لازم تتسحب عشان الصورة تتغير
    LOCK: 12, // بكسل قبل ما نقرر: سحب أفقي ولا سكرول رأسي
    CLICK_GUARD: 12, // أقل مسافة سحب تخلينا نلغي الكليك اللي وراها
    GUARD_MS: 260, // مدة الإلغاء — بتتلغي فورًا مع أول لمسة جديدة
    FLICK_PX: 36, // سحبة سريعة قصيرة كفاية إنها تعدّي
    FLICK_MS: 280,
  };

  /* ============================================================
     حارس السكرول.

     أخطر حالة في الجاليري: اليوزر بيعمل سكرول رأسي وصباعه واقع على
     صورة منتج. لو الحركة اتفسّرت غلط ولو للحظة، الكارت بيبدأ يتزحلك
     أفقيًا *والصفحة بتنزل في نفس الوقت* — وده بالظبط الإحساس بالتهنيج.

     الحل: لو لسه فيه سكرول شغال (أو momentum على iOS لسه بيهدى)،
     مبنسلّحش السحب أصلاً. الـ listener passive وبيكتب رقم واحد بس،
     فتكلفته صفر عمليًا.
     ============================================================ */
  let lastScrollAt = 0;
  window.addEventListener(
    'scroll',
    function () {
      lastScrollAt = performance.now();
    },
    { passive: true, capture: true }
  );

  /* كتابة الـ transform بتتجمّع في frame واحد.
     قبل كده كانت style.setProperty بتتنفذ مع كل pointermove (60–120 مرة
     في الثانية)، وكل واحدة بتبطّل صلاحية الـ style وتفرض إعادة حساب —
     شغل مكرر بالكامل لأن الشاشة بترسم مرة واحدة كل frame بس. */
  let dragRaf = 0;

  function flushDrag() {
    dragRaf = 0;
    if (drag.track) drag.track.style.setProperty('--card-m-drag', drag.dx + 'px');
  }

  function cancelDragFrame() {
    if (!dragRaf) return;
    cancelAnimationFrame(dragRaf);
    dragRaf = 0;
  }

  const drag = {
    card: null,
    track: null,
    id: null,
    x: 0,
    y: 0,
    dx: 0,
    rawDx: 0,
    width: 1,
    active: false,
    t: 0,
  };

  // إلغاء الكليك بيتخزّن هنا مربوط بالكارت اللي اتسحب هو بالظبط،
  // مش في dataset على الإلمنت — عشان ميفضلش عالق ويبلع كليكة كارت تاني
  const SUPPRESS = { card: null, until: 0 };

  function clearSuppress() {
    SUPPRESS.card = null;
    SUPPRESS.until = 0;
  }

  function slidesOf(card) {
    return card.querySelectorAll(GAL.slide);
  }

  /* تنزيل صورة سلايد واحدة — بتتنفذ مرة واحدة بس لكل صورة */
  function loadSlide(card, index) {
    if (index < 0) return;

    const slide = slidesOf(card)[index];
    if (!slide) return;

    const img = slide.querySelector('img[data-src]');
    if (!img) return;

    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    img.src = img.dataset.src;
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');

    if (img.complete && img.naturalWidth > 0) {
      img.classList.add('is-ready');
    } else {
      img.addEventListener('load', () => img.classList.add('is-ready'), { once: true });
      img.addEventListener('error', () => img.classList.add('is-ready'), { once: true });
    }
  }

  /* أول إشارة نية من اليوزر: بننزّل الصورة الجاية بس */
  function primeGallery(card) {
    if (!card || card.dataset.primed === '1') return;
    card.dataset.primed = '1';
    loadSlide(card, 1);
  }

  function setIndex(card, i) {
    const slides = slidesOf(card);
    if (!slides.length) return;

    const next = Math.max(0, Math.min(slides.length - 1, i));
    const track = card.querySelector(GAL.track);

    card.dataset.slide = String(next);
    if (track) track.style.setProperty('--card-m-slide', next);

    card.querySelectorAll(GAL.dot).forEach((dot, di) => {
      dot.classList.toggle('is-active', di === next);
      dot.setAttribute('aria-current', di === next ? 'true' : 'false');
    });

    card.dataset.primed = '1';
    loadSlide(card, next);
    loadSlide(card, next + 1); // نجهّز اللي بعدها عشان السحبة الجاية تبقى فورية
    loadSlide(card, next - 1);
  }

  function currentIndex(card) {
    return parseInt(card.dataset.slide || '0', 10) || 0;
  }

  /* مقاومة عند أول وآخر صورة عشان يحس إن مفيش حاجة بعدها */
  function resist(card, dx) {
    const idx = currentIndex(card);
    const last = slidesOf(card).length - 1;
    if ((idx === 0 && dx > 0) || (idx === last && dx < 0)) return dx * 0.32;
    return dx;
  }

  function resetDrag() {
    cancelDragFrame();
    drag.card = null;
    drag.track = null;
    drag.id = null;
    drag.active = false;
    drag.dx = 0;
    drag.rawDx = 0;
  }

  document.addEventListener(
    'pointerdown',
    function (event) {
      // لو جيستشر قديم اتقطع من غير pointerup (بيحصل كتير على الموبايل)
      // بننضّف أي أثر سايبه ورا الأول.
      // endDrag(false) بينضّف التراك اللي احنا ماسكينه فعلاً، فمفيش داعي
      // لـ querySelectorAll على الدوكيومنت كله في كل ضغطة في الصفحة.
      if (drag.card) endDrag(false);

      // وبعدين أي لمسة جديدة بتلغي أي حظر كليك قديم على طول.
      // ده اللي بيمنع إن سحبة على كارت تبلع أول ضغطة على كارت تاني.
      clearSuppress();

      if (event.button != null && event.button > 0) return;

      // الصفحة لسه بتسكرول (أو الـ momentum لسه بيهدى)؟ اللمسة دي
      // غالبًا لوقف السكرول مش لسحب صورة — منسلّحش الجاليري.
      if (performance.now() - lastScrollAt < 250) return;

      const track = event.target.closest(GAL.track);
      if (!track) return;

      const card = track.closest(SELECTORS.card);
      if (!card || slidesOf(card).length < 2) return;

      /* ============================================================
         كارت جوّه كاروسيل: السحب الأفقي للكاروسيل الأب، مش لصور الكارت.

         كل كارت منتج جوّاه سلايدر صور خاص بيه بيسحب أفقي. لما الكارت
         يبقى جوّه سلايدر تاني (fc-pro / المنتجات المرتبطة)، الاتنين
         بيتنططوا على نفس الجيستشر: الكارت بيزحلق صوره والكاروسيل
         بيحاول يلف — والنتيجة إن السحبة "بتعلق" ومش بتودّي لأي مكان.

         السلايدر الأب أولى: هو اللي المستخدم شايفه وبيتوقع يحركه.
         صور الكارت لسه بتتبدّل بالهوفر وبالنقط زي ما هي.

         [data-viewport] هو إطار إمبلا — فده بيغطي أي سكشن بيستخدم
         نفس المحرك، الموجود منهم والجاي.
         ============================================================ */
      if (card.closest('[data-viewport]')) return;

      drag.card = card;
      drag.track = track;
      drag.id = event.pointerId;
      drag.x = event.clientX;
      drag.y = event.clientY;
      drag.dx = 0;
      drag.rawDx = 0;
      drag.width = track.offsetWidth || 1;
      drag.active = false;
      drag.t = Date.now();

      primeGallery(card);
    },
    { passive: true }
  );

  document.addEventListener(
    'pointermove',
    function (event) {
      if (!drag.card || event.pointerId !== drag.id) return;

      const dx = event.clientX - drag.x;
      const dy = event.clientY - drag.y;

      if (!drag.active) {
        const adx = Math.abs(dx);
        const ady = Math.abs(dy);

        /* ============================================================
           قفل المحور: أول محور يعدّي الحد هو اللي بيكسب، والقرار نهائي.

           الكود القديم كان بيفحص الرأسي *بعد* ما الأفقي يعدّي 12px بس.
           يعني لو صباعك عمل قوس (وده الشكل الطبيعي لأي سكرول بالإبهام)
           وأول 12px طلعوا أفقيين، السحب كان بيتفعّل — وبعدها الكارت
           بيتزحلق أفقيًا والصفحة بتنزل رأسيًا في نفس الوقت.
           ============================================================ */
        if (ady > GAL.LOCK && ady >= adx) {
          resetDrag(); // نية رأسية واضحة — سيبها للصفحة
          return;
        }
        if (adx < GAL.LOCK || adx <= ady) return; // لسه مش واضح

        drag.active = true;
        drag.track.classList.add('is-dragging');
      }

      drag.rawDx = dx;
      drag.dx = resist(drag.card, dx);
      if (!dragRaf) dragRaf = requestAnimationFrame(flushDrag);
    },
    { passive: true }
  );

  function endDrag(commit, event) {
    if (!drag.card) return;

    const card = drag.card;
    const track = drag.track;
    const travelled = Math.abs(drag.rawDx);
    const wasDragging = drag.active;

    // لازم نلغي أي كتابة معلّقة الأول، وإلا هتتنفذ بعد التصفير
    // وتسيب التراك مزحلق بمقدار آخر حركة
    cancelDragFrame();

    track.classList.remove('is-dragging');
    track.style.setProperty('--card-m-drag', '0px');

    if (commit && wasDragging) {
      const ratio = drag.dx / drag.width;
      const quick = Math.abs(drag.dx) > GAL.FLICK_PX && Date.now() - drag.t < GAL.FLICK_MS;
      const idx = currentIndex(card);

      if (ratio < -GAL.THRESHOLD || (quick && drag.dx < 0)) setIndex(card, idx + 1);
      else if (ratio > GAL.THRESHOLD || (quick && drag.dx > 0)) setIndex(card, idx - 1);
    }

    // الكليك اللي بيجي ورا سحبة حقيقية بس هو اللي بيتلغي
    if (wasDragging && travelled >= GAL.CLICK_GUARD) {
      SUPPRESS.card = card;
      SUPPRESS.until = Date.now() + GAL.GUARD_MS;
    } else {
      clearSuppress();
    }

    const tapped = !wasDragging && commit && event ? tapTarget(event) : null;

    resetDrag();

    // ============================================================
    // اللمسة العادية بنودّيها بنفسنا بدل ما نستنى الـ click.
    // المتصفحات على الموبايل بتبلع أول click بعد أي جيستشر سحب،
    // وده كان سبب إن أول ضغطة على كارت تاني متعملش حاجة.
    // على الماوس بنسيب المتصفح يشتغل عادي (عشان فتح في تاب جديد وخلافه).
    // ============================================================
    if (tapped) window.location.assign(tapped);
  }

  /* بترجع اللينك لو اللمسة كانت ضغطة نضيفة على صورة الكارت */
  function tapTarget(event) {
    if (!event || event.pointerType === 'mouse') return null;
    if (Date.now() - drag.t > 600) return null; // ضغطة مطوّلة، مش ضغطة عادية

    const dist = Math.abs(event.clientX - drag.x) + Math.abs(event.clientY - drag.y);
    if (dist > GAL.CLICK_GUARD) return null;

    const el = event.target;
    if (!el || !el.closest) return null;

    // الدوتس وزرار الإضافة السريعة ليهم شغلهم الخاص
    if (el.closest(GAL.dot) || el.closest('.card-m__quick')) return null;

    const link = el.closest('.card-m__slide');
    return link && link.href ? link.href : null;
  }

  document.addEventListener('pointerup', (e) => endDrag(true, e), { passive: true });
  document.addEventListener('pointercancel', () => endDrag(false), { passive: true });

  document.addEventListener(
    'click',
    function (event) {
      if (!SUPPRESS.card) return;

      // اتأخرنا؟ أو الكليك على كارت تاني خالص؟ نمسح الحظر ونسيب الكليك يعدّي
      if (Date.now() > SUPPRESS.until || !SUPPRESS.card.contains(event.target)) {
        clearSuppress();
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      clearSuppress();
    },
    true
  );

  /* ---------- الدوتس ---------- */

  document.addEventListener('click', function (event) {
    const dot = event.target.closest(GAL.dot);
    if (!dot) return;

    event.preventDefault();
    event.stopPropagation();

    const card = dot.closest(SELECTORS.card);
    if (card) setIndex(card, Number(dot.dataset.index || 0));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;

    const dot = event.target.closest && event.target.closest(GAL.dot);
    if (!dot) return;

    const card = dot.closest(SELECTORS.card);
    if (!card) return;

    event.preventDefault();
    setIndex(card, currentIndex(card) + (event.key === 'ArrowRight' ? 1 : -1));
  });

  /* ---------- الهوفر على الديسكتوب ---------- */

  /* ============================================================
     listener واحد للهوفر بدل تلاتة.

     كان في 3 listeners على الدوكيومنت (pointerover للهوفر، pointerover
     للجاليري، mouseover للسواتش) وكل واحد بيعمل closest() لوحده على
     *نفس* الحدث. الماوس وهو ماشي فوق grid فيه 40 كارت بيولّد مئات
     الأحداث في الثانية، فده كان 3 أضعاف الشغل من غير أي داعي.
     ============================================================ */
  if (canHover) {
    document.addEventListener(
      'pointerover',
      function (event) {
        const target = event.target;
        if (!target || !target.closest) return;

        // 1) هوفر السواتش → تبديل صورة الكارت (بعد نية واضحة)
        const swatch = target.closest(SELECTORS.swatch);
        if (swatch) {
          if (swatch !== lastSwatch) {
            lastSwatch = swatch;
            /* ============================================================
               تأخير نية 110ms قبل تبديل الصورة.

               كل تبديل بيسحب صورة 550px من الشبكة ويفكّها. من غير
               التأخير، ماوس بيعدّي فوق 3 سواتشات في طريقه لحاجة تانية
               كان بيولّد 3 تحميلات + 3 عمليات decode على الـ main thread
               من غير ما اليوزر يكون طالب أي حاجة.

               الكليك بيفضل فوري — التأخير على الهوفر بس.
               ============================================================ */
              clearTimeout(swatchTimer);
              swatchTimer = setTimeout(function () {
                if (lastSwatch === swatch && swatch.isConnected) swapImage(swatch);
              }, 110);
          }
          return; // السواتش جوه الـ body، مفيش شغل جاليري وراه
        }

        const card = target.closest(SELECTORS.card);
        if (!card) return;

        // 2) تحميل صورة الهوفر عند الحاجة
        loadHoverImage(card);

        // 3) الجاليري
        if (!card.classList.contains('card-m--gallery')) return;
        primeGallery(card);

        // بس أول ما الماوس يدخل الكارت من بره
        if (card.dataset.hoverNext === '1' && !card.contains(event.relatedTarget)) {
          setIndex(card, 1);
        }
      },
      { passive: true }
    );

    document.addEventListener(
      'pointerout',
      function (event) {
        const card = event.target.closest && event.target.closest(GAL.card);
        if (!card || card.contains(event.relatedTarget)) return;
        if (card.dataset.hoverNext === '1') setIndex(card, 0);
      },
      { passive: true }
    );
  }

  /* ============================================================
     أنيميشن الظهور
     ============================================================ */

  const ANIM = {
    observer: null,
    enabled: true,
    STAGGER: 50, // فرق التوقيت بين كل كارت والتاني
    MAX_STEPS: 5, // بحد أقصى 250ms، عشان آخر كارت في الصف ميستناش كتير
  };

  function animationsAllowed() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;

    const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (conn && conn.saveData) return false;

    /* ============================================================
       فحص effectiveType اتشال — وده كان سبب "مش شغال على الموبايل
       أول مرة، وبيشتغل بعد الريفريش".

       الحُرّاس التانية كلها ثابتة على نفس الجهاز: تقليل الحركة،
       الرام، عدد الأنوية. مستحيل واحد منهم يخلي التحميل الأول
       يختلف عن الريفريش. effectiveType هي الوحيدة اللي بتتغيّر.

       والسبب إنها **مش** نوع الشبكة: دي تقدير المتصفح محسوب من
       زمن الاستجابة والسرعة. على الموبايل في أول تحميل العينات
       لسه قليلة فالتقدير بيبدأ متشائم ("2g") حتى على خط كويس،
       وبعد الريفريش بيكون اتحسّن. على الكمبيوتر بيبلّغ "4g"
       دايمًا — عشان كده المشكلة مكانتش بتظهر هناك.

       والقرار بيتاخد مرة واحدة في <head> وبيحط card-m-no-anim
       اللي بيفضل طول عمر الصفحة، فحتى لو الشبكة اتحسّنت بعد
       ثانية الأنيميشن بيفضل مقفول.

       والحركة نفسها transition على opacity و transform — بتتنفّذ
       على كارت الشاشة ومبتحمّلش الشبكة ولا بايت. فالربط بينها
       وبين تقدير سرعة النت مكانش في محله من الأساس.

       saveData فضلت: دي اختيار صريح من المستخدم مش تقدير.
       ============================================================ */

    // أجهزة ضعيفة: أقل من 2 جيجا رام أو أقل من 4 أنوية
    if (typeof navigator.deviceMemory === 'number' && navigator.deviceMemory < 2) return false;
    if (typeof navigator.hardwareConcurrency === 'number' && navigator.hardwareConcurrency < 4) return false;

    return true;
  }

  function initAnimations() {
    ANIM.enabled = animationsAllowed() && 'IntersectionObserver' in window;

    if (!ANIM.enabled) {
      document.documentElement.classList.add('card-m-no-anim');
      return;
    }

    ANIM.observer = new IntersectionObserver(
      (entries, observer) => {
        let step = 0;

        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          observer.unobserve(entry.target);
          entry.target.dataset.seen = '1';

          // التدرّج بيتحسب على الكروت اللي دخلت الشاشة مع بعض في نفس اللحظة
          if (step > 0) {
            entry.target.style.setProperty(
              '--card-m-delay',
              Math.min(step, ANIM.MAX_STEPS) * ANIM.STAGGER + 'ms'
            );
          }
          step += 1;

          maybeReveal(entry.target);
        });
      },
      {
        // بيشتغل ساعة ما الكارت يبدأ يدخل الشاشة فعلاً — عشان تشوف الحركة
        rootMargin: '0px 0px -5% 0px',
        threshold: 0,
      }
    );
  }

  function armCards(root) {
    if (!ANIM.enabled || !ANIM.observer) return;

    const cards = (root || document).querySelectorAll('.card-m--anim:not([data-anim])');
    if (!cards.length) return;

    cards.forEach((card) => {
      card.dataset.anim = 'set';
      card.classList.add('is-armed');
    });

    // لازم المتصفح يرسم الحالة المبدئية الأول، وإلا الانتقال بيتلغي
    // وتلاقي الكارت ظهر فجأة من غير حركة. الـ rAF المزدوجة بتضمن إطار كامل.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        cards.forEach((card) => ANIM.observer.observe(card));
      });
    });

    // لو صورة اتعلّقت في التحميل، بنكشف الكارت بعد 4 ثواني على أي حال
    setTimeout(() => {
      cards.forEach((card) => {
        if (card.dataset.seen === '1') card.classList.add('is-visible');
      });
    }, 4000);
  }

  /* واجهة عامة للسكاشن اللي بتحقن كروت بعد تحميل الصفحة */
  window.CardModern = window.CardModern || {};
  window.CardModern.scan = function (root) {
    scanLoadedImages(root);
    armCards(root);
  };

  /* ---------- التشغيل ---------- */

  function boot() {
    initAnimations();
    scanLoadedImages();
    armCards();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => window.CardModern.scan(e.target));
  document.addEventListener('related-products:loaded', (e) => window.CardModern.scan(e.target));

  /*
    Theme Editor: a section can be removed while its Quick View is open.

    The overlay itself is a singleton (buildOverlay early-returns once it
    exists), so it does not accumulate — but openQuickView sets
    document.body.style.overflow = 'hidden', and if the section that opened it
    disappears, nothing ever restores that. The editor preview is then stuck
    permanently unscrollable, with a panel showing markup from a section that
    no longer exists.

    closeQuickView() restores the overflow, clears the panel and returns focus,
    so it is the correct teardown here — the overlay stays for reuse.
  */
  document.addEventListener('shopify:section:unload', (e) => {
    if (!QV.overlay || !QV.overlay.classList.contains('is-open')) return;
    if (e.target && e.target.contains && e.target.contains(QV.trigger)) {
      QV.trigger = null; // its section is going away; do not focus a detached node
    }
    closeQuickView();
  });
})();